module.exports = __webpack_public_path__ + "media/images/favicons/favicon-b4449f274966e3c4099bc1e620239c59.ico";